<template>
	<div id="IndividualEditor">
		<div class="individual-editor">
			<span class="dasai ds_guanbi1"  @click="guanbi1()"></span>
			<div class="individual-editor-top">
				<div class="individual-editor-tl" @click="chooseType" >
					<img v-show="!form.Photo" class="add-image"  src="../../assets/暂无头像.jpg" alt="">
					<img v-show="form.Photo" class="list" :src="form.RootPath+form.Photo" />
				</div>
				<input id="upload_file" type="file" class="file-input" accept="image/png,image/jpeg,image/jpg" :multiple="multiple"
				 @change="inputChange" style="display: none" />
				<div class="individual-editor-tr">
					<p v-if='!UserName' style="font-size: 18px;margin-top: 20px;"><input placeholder="填写真实姓名" maxlength="5" style="outline:none;display: inline-block;width:110px;border: none;border-bottom: 1px solid #333;font-size: 18px;"
						 v-model="form.UserName"></input><span class="ds_bianji-copy-copy dasai"></span><i style="font-size: 12px;">(最多五个字且只能设置一次)</i></p>
					<p v-if='UserName' style="font-size: 18px;margin-top: 20px;"><span style="outline:none;display: inline-block;width:90px;border: none;font-size: 18px;"
						 v-text="form.UserName"></span></p>
					<p class="declaration"><span>参赛宣言</span>
						<el-input maxlength="25" show-word-limit style='width: 494px;' v-model="form.Declaration" placeholder="请输入内容"></el-input>
					</p>
					<div class="individual-editor-other">
						<p class="individual-editor-other-l">
							<span>机构名称</span>
							<el-input style='width: 194px;' v-model="form.Org" placeholder="XX银行XX分行"></el-input>
						</p>
						<p class="individual-editor-other-r">
							<span>所在地区</span>
							<el-select style='width: 100px;padding: 0;' @change='changeFun()' v-model="form.ProvinceId" placeholder="请选择省">
								<el-option v-for="item in ProvinceArr" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
							<el-select style='width: 100px;padding: 0;' v-model="form.CityId" placeholder="请选择市">
								<el-option v-for="item in CityArr" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</p>
					</div>

					<div class="individual-editor-other">
						<p class="individual-editor-other-l">
							<span>专业擅长</span>
							<el-select v-model="form.Major" multiple placeholder="请选择">
								<el-option v-for="item in MajorArr" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</p>
						<p class="individual-editor-other-r">
							<span>从业时间</span>
							<el-input type='number' style='width: 170px;margin-right: 10px;' v-model="form.WorkingStart" placeholder="请输入内容"></el-input>年
						</p>
					</div>

					<div class="individual-editor-other">
						<p class="individual-editor-other-l">
							<span>持证类型</span>
							<!-- <el-select v-model="form.Cert" multiple placeholder="请选择">
								<el-option v-for="item in CertArr" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select> -->
							<el-select v-model="form.Cert" multiple placeholder="请选择">
								<el-option v-for="item in CertArr" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</p>
					</div>
				</div>
			</div>
			<div class="introduction-text">
				<h1>个人简介</h1>
				<el-input type="textarea" style="height: 290px" placeholder="请输入内容" v-model="form.Introduction" maxlength="300"
				 show-word-limit>
				</el-input>
			</div>
			<button class="save" @click="savefun()">保存</button>
		</div>

	</div>
</template>

<script>
	import { showLoading, hideLoading } from '@/assets/loading.js';
	export default {
		data() {
			return {
				UserName: '',
				list: '',
				form: {
					UserName: '', //名称
					Declaration: '', //宣言
					Introduction: '', //介绍
					WorkingStart: '', //从业时间
					ProvinceId: 0, //省
					Org: '',
					CityId: 0, //市
					Cert: [], //持证
					Major: [], //擅长
				},
				guanbi: 0,
				input: '',
				value: '',
				ProvinceArr: [],
				CityArr: [],
				MajorArr: [{
					label: '保险规划',
					value: 1,
				}, {
					label: '投资管理',
					value: 2,
				}, {
					label: '理财规划',
					value: 3,
				}, {
					label: '传承安排',
					value: 4,
				}, {
					label: '综合服务',
					value: 5,
				}], //sc
				CertArr: [{
					label: 'CHFP理财规划师证书',
					value: 1,
				}, {
					value: 2,
					label: 'CFA特许金融分析师'
				}, {
					value: 3,
					label: 'CHFA买方理财顾问'
				}, {
					value: 4,
					label: 'CFP国际金融理财师'
				}, {
					value: 5,
					label: 'AFP金融理财师'
				}], //czlx
				value1: [],
			}
		},
		created() {
			this.getProvince()
			// this.getProvinceCity()
			this.getmember()
		},
		props: {
			multiple: false,
			max: 1,
		},
		methods: {
			// 上传图片
			chooseType() {
				document.getElementById("upload_file").click();
			},
			async inputChange(e) {
				let files = e.target.files;
				console.log(files)
				let uploadAll = [].slice.call(files, 0).map(this.upload);
				//使用object.values(files)，测试安卓存在兼容性问题，替换为[].slice.call(files ,0)
				console.log(uploadAll)
				showLoading();
				let result = await Promise.all(uploadAll);
				document.getElementById("upload_file").value = "";
			},
			upload(file, index) {
				console.log(file)
				return new Promise(async (resolve, reject) => {
					let form = new FormData();
					console.log(this.axios)
					form.append("file", file);
					let result = this.axios.post("/api/member/UploadPhoto", form)
						.then(response => {
							console.log(response.data.data[0])
							this.form.Photo = response.data.data[1]
							// this.list = response.data.data[0]
							hideLoading();
						}).catch(error => {
							console.log(error)
						});
				});
			},
			// 上传结束
			
			guanbi1() {
				this.$emit('Indguanbi', this.guanbi)
			},
			getmember() {
				this.axios.get('/api/member/GetMember')
					.then(res => {
						console.log(res.data.data)
						this.form = res.data.data
						this.UserName = res.data.data.UserName
						// this.list = res.data.data.Photo
						if (this.form.ProvinceId >= 0) {
							this.getProvinceCity()
						}
					})
					.catch(error => {
						console.log(error)
					})
			},
			savefun() {
				console.log(this.form)
				this.axios.post('/api/member/UpdateMember', this.form)
					.then(res => {
						console.log(res)
						if (res.data.Success) {
							this.$message({
								message: '保存成功！',
								type: 'success'
							});

						} else {
							this.$message({
								message: res.data.ErrorMsg,
								type: 'error'
							});
						}
						this.$emit('Indguanbi', this.guanbi)
					})
					.catch(error => {
						console.log(error)
					})
			},
			changeFun() {
				console.log(this.form.ProvinceId)
				this.getProvinceCity()
			},
			getProvince() {
				var url = '/api/ProvinceCity/GetList'
				this.axios.get(url)
					.then(res => {
						console.log(res)
						this.ProvinceArr = res.data.data
					})
					.catch(error => {
						console.log(error)
					})
			},
			getProvinceCity() {

				var url = '/api/ProvinceCity/GetList?Id=' + this.form.ProvinceId

				this.axios.get(url)
					.then(res => {
						console.log(res)
						this.CityArr = res.data.data
					})
					.catch(error => {
						console.log(error)
					})
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#IndividualEditor {
		position: fixed;
		top: 0;
		left: 0;
		color: #333;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
z-index: 2;
		.individual-editor {
			span {
				white-space: nowrap;
			}

			.ds_guanbi1 {
				position: absolute;
				top: 10px;
				right: 10px;
				font-size: 20px;
			}

			overflow: scroll;
			width: 800px;
			height: 700px;
			background: #fff;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			margin: auto;
			border-radius: 5px;
			padding: 30px 20px;

			.individual-editor-top {
				width: 100%;
				overflow: hidden;

				.individual-editor-tl {
					width: 130px;
					height: 170px;
					background: #c8c8d7;
					float: left;
					overflow: hidden;
					display: flex;
					align-items: center;
					img{
						width: 100%;
						opacity: 0.5;
					}
				}

				.individual-editor-tr {
					width: 600px;
					float: right;

					.ds_bianji-copy-copy {
						font-size: 20px;
					}
				}
			}

			.declaration {
				font-size: 14px;
				margin-top: 20px;
				display: flex;
				align-items: center;

				span {
					margin-right: 10px;
				}

				input {
					flex: 1
				}
			}

			.individual-editor-other {
				display: flex;
				font-size: 14px;
				margin-top: 20px;

				input {
					width: 100px
				}

				span {
					margin-right: 10px
				}

				.individual-editor-other-l {
					width: 50%;
					display: flex;
					align-items: center
				}

				.individual-editor-other-r {
					width: 50%;
					display: flex;
					align-items: center
				}
			}

			.introduction-text {
				width: 100%;
				height: 335px;
				margin-top: 20px;
				border: 1px solid #3e1976;
				border-radius: 10px;
				overflow: hidden;

				h1 {
					text-align: center;
					background: #3e1976;
					color: #fff;
					height: 40px;
					font-size: 16px;
					line-height: 40px;
				}

			}

			.save {
				background: #3e1976;
				color: #fff;
				border-radius: 30px;
				display: block;
				margin: 0 auto;
				padding: 5px 30px;
				margin-top: 10px
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/common/IndividualEditor.vue